import { memo, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Box, CircularProgress, Grid2, Typography } from "@mui/material";
import { Image } from "mui-image";

import Card from "../components/Card.js";
import { useSnackbar } from "../utils/index.js";
import { getScores, getStatistics } from "../api/index.js";
import Spinner from "../components/Spinner.js";
import LeaderboardComponent from "../components/Leaderboard.js";
import logo from "../assets/logo.png";

const Home = () => {
	const [statistics, setStatistics] = useState({});
	const [leaderboard, setLeaderboard] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isLeaderboardLoading, setIsLeaderboardLoading] = useState(true);
	const { error } = useSnackbar();
	
	const fetchStatistics = async () => {
		setIsLoading(true);
		const { success: fetchSuccess, statistics: fetchedStatistics, message } = await getStatistics();
		if (fetchSuccess) {
			setStatistics(fetchedStatistics);
		} else {
			error(message);
		}

		setIsLoading(false);
	};

	const fetchLeaderboard = async () => {
		setIsLoading(true);
		const { success: fetchSuccess, scores: fetchedLeaderboard, message } = await getScores();
		if (fetchSuccess) {
			setLeaderboard(fetchedLeaderboard.slice(0, 3));
		} else {
			error(message);
		}

		setIsLoading(false);
		setIsLeaderboardLoading(false);
	};
	
	useEffect(() => {
		fetchStatistics();
		fetchLeaderboard();
	}, []);
	
	return (
		<>
			<Spinner open={isLoading} />
			<Grid2 container direction="column" alignItems="center" justifyContent="center" mt={5}>
				<Box component={Link} to="/">
					<Image src={logo} alt="Logo" sx={{ p: 0, my: 0, height: "100%", maxWidth: "350px" }} />
				</Box>
				<Typography variant="h3" mt={3} sx={{ color: "third.main", p: 1, fontWeight: "bold" }}>{"Welcome"}</Typography>
				<Typography variant="h5" sx={{ color: "primary.main", p: 1 }}>{"to the Locsys - PreSFHMMY 9 Dashboard!"}</Typography>

				<Grid2 width="100%" mt={5} container display="flex" justifyContent="space-between">
					<Card title="Number of Users" titleFontSize={22} width="300px">
						<Typography fontSize={30} fontWeight="bold" color="third" align="center" sx={{ textAlign: "center" }}>{statistics?.numberOfUsers ?? "-"}</Typography>
					</Card>

					<Card title="Number of Teams" titleFontSize={22} width="300px">
						<Typography fontSize={30} fontWeight="bold" color="third" align="center" sx={{ textAlign: "center" }}>{statistics?.numberOfTeams ?? "-"}</Typography>
					</Card>

					<Card title="Number of Tasks" titleFontSize={22} width="300px">
						<Typography fontSize={30} fontWeight="bold" color="third" align="center" sx={{ textAlign: "center" }}>{statistics?.numberOfTasks ?? "-"}</Typography>
					</Card>
				</Grid2>

				<Grid2 width="100%" mt={5}>
					<Card title="Top 3 Teams" titleFontSize={22} width="100%">
						{isLeaderboardLoading
							? (
								<Grid2 container justifyContent="center">
									<CircularProgress color="third" size={60} />
								</Grid2>
							)
							: <LeaderboardComponent leaderboard={leaderboard} />
						}
					</Card>
				</Grid2>
			</Grid2>
		</>

	);
};

export default memo(Home);
